import fp from "fingerprintjs2";

// Callback do fingerprintjs2 em Promise. Rejeita no timeout ou se a coleta lançar erro.
export const getFingerprint = ({ excludes = {}, timeoutMs } = {}) =>
  new Promise((resolve, reject) => {
    let settled = false;
    let timer = null;

    const finish = (settle, value) => {
      if (settled) return;
      settled = true;
      if (timer) clearTimeout(timer);
      settle(value);
    };

    if (timeoutMs) {
      timer = setTimeout(() => {
        const error = new Error('fingerprint timeout');
        error.name = 'TimeoutError';
        finish(reject, error);
      }, timeoutMs);
    }

    try {
      const options = Object.keys(excludes).length ? { excludes } : {};
      fp.get(options, (components) => {
        finish(resolve, components);
      });
    } catch (error) {
      finish(reject, error);
    }
  });
